import ReactApexChart from "react-apexcharts";

const ERGParticipation = (data: any) => {

  if (!data || !data.data) {
    return <div>Unable to load chart data.</div>;
  }

  // Filter valid data entries - try multiple possible field names
  const filteredData = data.data.filter(
    (item: any) => item.count !== null && item.resource_group !== null
  );

  if (filteredData.length === 0) {
    return (
      <div id="chart-erg-participation">
        <h3>
          Over the past year, have you been involved in any TTEC Employee
          Resource Groups (ERGs)?
        </h3>
        <div>No data available for this chart.</div>
      </div>
    );
  }

  // Extract data for chart - check multiple possible field names
  const chartData = filteredData.map((item: any) => item.count);
  const categories = filteredData.map((item: any) => item.resource_group);

  const series = [
    {
      name: "ERG Participation",
      data: chartData,
    },
  ];

  const options = {
    chart: {
      type: "bar" as "bar",
      events: {
        dataPointSelection: (event: any, chartContext: any, config: any) => {
          try {
            if (
              config &&
              config.w &&
              config.w.config &&
              config.w.config.xaxis &&
              config.w.config.xaxis.categories &&
              typeof config.dataPointIndex === "number" &&
              config.dataPointIndex >= 0 &&
              config.dataPointIndex < config.w.config.xaxis.categories.length
            ) {
            }
          } catch (error) {
          }
        },
      },
    },
    xaxis: {
      categories: categories,
    },
    legend: {
      position: "bottom" as "bottom",
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        horizontal: true,
        distributed: true, // This enables separate color for each bar
      },
    },
    dataLabels: {
      enabled: true,
    },
    colors: [
      "#FF6384",
      "#36A2EB",
      "#FFCE56",
      "#4BC0C0",
      "#4ca7a7ff",
      "#9966FF",
      // "#C0C0C0",
      "#FF69B4",
      "#FF4500",
      "#FF7F50",
      "#FFDAB9",
      "#FFB6C1",
      "#FF8C00",
      "#FFA07A",
      "#FFA500",
      "#FFD700",
      "#FFC0CB",
      "#FF69B4",
      "#FF1493",
      "#FF00FF",
      "#800080",
    ], // Add more colors if needed
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 250,
          },
          legend: {
            position: "bottom" as "bottom",
          },
        },
      },
    ],
  };

  return (
    <div id="chart-erg-participation">
      <h3>
        Over the past year, have you been involved in any TTEC Employee Resource
        Groups (ERGs)?
      </h3>
      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        width={480}
      />
    </div>
  );
};

export default ERGParticipation;
